import {Icon, IconButton, Tooltip} from "@mui/material";
import {
    useArquivar,
    useArquivarFluxo,
    useDesarquivar,
    useDesarquivarFluxo
} from "../../api/DpgeIntegracaoEsfingeApi";
import {useLoading} from "../loading/LoadingProvider";

function ArquivarButton({ocorrencia}) {
    const {mutateAsync: arquivar} = useArquivar();
    const {mutateAsync: arquivarFluxo} = useArquivarFluxo();
    const {mutateAsync: desarquivar} = useDesarquivar();
    const {mutateAsync: desarquivarFluxo} = useDesarquivarFluxo();
    const setLoading = useLoading();
    const possuiEtapas = ocorrencia.ocorrenciasFilhas?.length > 0;
    const acao = ocorrencia.arquivado ? "Desarquivar" : "Arquivar";
    const titulo = possuiEtapas
        ? `${acao} o fluxo e todas as etapas vinculadas`
        : acao;

    return (
        <Tooltip title={titulo}>
            <IconButton
                edge="end"
                aria-label={titulo}
                onClick={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setLoading(true);
                    try {
                        if (ocorrencia.arquivado) {
                            await (possuiEtapas
                                ? desarquivarFluxo
                                : desarquivar)(ocorrencia.id);
                        } else {
                            await (possuiEtapas ? arquivarFluxo : arquivar)(
                                ocorrencia.id
                            );
                        }
                        ocorrencia.arquivado = ocorrencia.arquivado
                            ? null
                            : "S";
                    } finally {
                        setLoading(false);
                    }
                }}
            >
                <Icon>{ocorrencia.arquivado ? "inventory" : "archive"}</Icon>
            </IconButton>
        </Tooltip>
    );
}

export default ArquivarButton;
